<template>
	<div class="select-member-page">
		<div class="left d-flex direction-column" v-loading="loading" element-loading-text="加载中...">
			<p class="header">
				班级列表
			</p>
			<div class="tree-box flex-1">
				<el-tree
					ref="tree"
					node-key="key"
					highlight-current
					show-checkbox
					@check="check"
					:filter-node-method="filterNode"
					:indent="25"
					:data="treeNodes"
					:props="defaultProps"
				>
					<span :ref="node.$treeNodeId" class="custom-tree-node" slot-scope="{ node }">
						<i :ref="node.id" v-show="false" class="el-icon-loading"></i>
						<span class="text" :title="node.label">{{ node.label }}</span>
					</span>
				</el-tree>
			</div>
		</div>
		<div class="right">
			<div class="header flex-center-between">
				<div class="num">已选中 {{ this.selectedNodes.length }} 个班级</div>
				<div class="empty" @click="empty()">清空</div>
			</div>
			<div class="list-box">
				<div v-show="!selectedNodes.length">
					<img src="../../register/img/class-nodata.svg" />
					<p class="no-data">暂无数据</p>
				</div>
				<ul>
					<li v-for="(item, index) in selectedNodes" :key="index" class="flex-center-between">
						<span :title="item.label" class="name ellipsis">{{ item.label }}</span>
						<span class="remove" @click="remove(item, index)">-</span>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	import localForage from "localforage";
	import dayjs from "dayjs";
	export default {
		name: "SelectMember",
		props: {
			// 应用此组件时，可在外部设置高度，默认 350
			height: {
				type: String,
				default: "350",
			},
			dialogVisible: {
				type: Boolean,
				default: false,
			},
			// grandsonObj: {
			// 	type: Object,
			// 	default: null,
			// },
		},
		data() {
			return {
				loading: false,
				tableData: [], //作业登记列表数据
				classList: [], //班级列表
				treeNodes: [],
				$treeNodeParent: null, //  树形控件虚拟父级节点对象
				defaultProps: {
					children: "children",
					label: "label",
					disabled: "disabled",
				},
				filterText: "",
				selectedNodes: [], // 右侧选中的节点列表
				selectedKeys: [], // 右侧选中的节点 id 集合
				reload: false, // 重新进入作业模块时 是否重新加载
				nodeKeySeed: 0,
			};
		},
		watch: {
			dialogVisible(newValue) {
				if (newValue) {
					this.listenReload();
					this.classAbandon();
					if (this.reload) this.getClassList();
				} else {
					this.reload = false;
					// 对话框关闭时，清空列表
					console.log("清空列表");
					// this.empty();
				}
			},
			filterText(val) {
				this.$refs.tree.filter(val);
			},
		},
		deactivated() {
			console.log("deactivated");
			this.getCommonList();
		},
		activated() {
			console.log("activated");
		},
		created() {
			console.log("$attrs--", this.$attrs);
			this.getCommonList();
		},
		mounted() {},
		methods: {
			//同科目同日期同班级不能布置两次作业
			classAbandon() {
				console.log("this.$attrs--", this.$attrs);
				let homeworkDate = dayjs(this.$attrs.homeworkDate).format("YYYY-MM-DD");
				console.log("homeworkDate----", homeworkDate);
				let res = this.tableData?.filter((item) => {
					return item.homeworkDate == homeworkDate && item.subjectId == this.$attrs.subjectId;
				});
				console.log("res---", res);
				if (!res.length) {
					this.treeNodes.forEach((item) => {
						this.$set(item, "disabled", false);
					});
					return;
				}
				console.log("this.treeNodes--", this.treeNodes);
				this.treeNodes.forEach((item) => {
					res?.forEach((item2) => {
						if (item.id == item2.classId) {
							// this.$set(this.treeNodes[index], "disabled", true);
							this.$set(item, "disabled", true);
						} else {
							this.$set(item, "disabled", false);
						}
					});
				});
			},
			//筛选默认选中的班级列表
			defaultCheckClass() {
				let classInfos = this.$attrs.classInfos;
			},
			// 获取班级列表
			async getCommonList() {
				this.classList = await localForage.getItem("classList");
				let list = this.classList;
				list = list.map((item) => {
					return { id: item.classId, label: item.className };
				});
				this.format(list);
				console.log("list----", list);
				this.treeNodes = list;
				//获取作业列表登记数据
				this.tableData = await localForage.getItem("tableData");
				this.tableData = this.tableData?.map((item) => {
					return {
						classId: item.classId,
						subjectId: item.subjectId,
						homeworkDate: item.homeworkDate,
					};
				});
				console.log("	this.tableData--", this.tableData);

				this.classAbandon();
			},
			// 格式化树节点，添加唯一key
			format(arr = []) {
				if (arr && arr.length) {
					arr.forEach((item) => {
						item.key = this.nodeKeySeed++;
						if (item.children && item.children.length) {
							this.format(item.children);
						}
					});
				}
			},
			// 监听重新加载
			listenReload() {
				this.$root.$off();
				// 监听来自班级管理页面 renderer/views/common/classmanage/page/index.vue的 shouldRefreshSelectMember 事件
				this.$root.$on("shouldRefreshSelectMember", () => {
					this.reload = true;
					console.log("reload-listen--", this.reload);
				});
			},
			// 获取最终选中的班级集合，由父组件调用
			getSelectedClasses() {
				let selectedNodes = this.selectedNodes;
				if (!selectedNodes.length) {
					this.$message({
						message: "请选择班级",
						type: "error",
						offset: 200,
						customClass: "toast-classManage",
						duration: 1500,
					});
					return [];
				} else {
					return selectedNodes;
				}
			},
			// 筛选树数据
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},

			// 当复选框被点击的时候触发  参数依次为 该节点所对应的对象、树目前的选中状态对象
			check(node, statusObj) {
				console.log("node--", node);
				console.log("statusObj--", statusObj);
				this.selectedNodes = statusObj.checkedNodes;
			},
			// 移除选中的班级
			remove(item, index) {
				this.$refs.tree.setChecked(item, false);
				this.selectedNodes.splice(index, 1);
			},

			// 清空选中班级
			empty() {
				console.log("selectedNodes--", this.selectedNodes);
				if (!this.selectedNodes.length) return;
				this.selectedNodes = [];
				this.$refs.tree.setCheckedKeys([]);
			},
		},
	};
</script>

<style lang="less" scoped>
	.select-member-page {
		display: flex;
		height: 100%;
		.left {
			position: relative;
			flex: 1;
			padding-left: 20px;
			border-bottom: 1px solid #ececec;
			border-right: 1px solid #e9e9e9;
			.header {
				padding-right: 40px;
				margin: 15px 0;
				font-weight: 500;
			}
			.tree-box {
				overflow-y: auto;
				overflow-x: hidden;
				::v-deep .el-tree-node__label {
					width: 70%;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
		}
		.right {
			flex: 1;
			border-bottom: 1px solid #ececec;
			padding-left: 20px;
			overflow: hidden;

			.header {
				height: 32px;
				margin-bottom: 20px;
				.num {
					color: #7c8293;
				}
				.empty {
					margin-right: 20px;
					color: #009efd;
					cursor: pointer;
				}
			}
			.list-box {
				height: calc(100% - 52px);
				overflow: auto;
				padding-right: 20px;
				div img {
					margin-top: 70px;
					width: 110px;
					height: 58px;
					margin-left: 42px;
				}
				.no-data {
					text-align: center;
					margin-top: 20px;
				}
				li {
					height: 26px;
					margin-bottom: 18px;
					color: #3c3c3c;
					.name {
						display: inline-block;
						width: 80%;
					}
					.remove {
						display: inline-block;
						width: 18px;
						height: 18px;
						border-radius: 50%;
						line-height: 15px;
						text-align: center;
						font-size: 24px;
						color: #fff;
						background-color: #dddddd;
						cursor: pointer;
						&:hover {
							background-color: #ff4f4f;
						}
					}
				}
			}
		}
	}

	::v-deep .el-tree-node__content {
		position: relative;
		margin-bottom: 18px;
		.custom-tree-node {
			width: calc(100% - 28px);
			.text {
				width: 90%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
	}
	::v-deep .el-tree-node__content:hover {
		background-color: #fff;
	}
	::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
		background-color: #fff;
	}
	::v-deep .el-tree-node:focus > .el-tree-node__content {
		background-color: #fff;
	}
	::v-deep .el-tree-node__label {
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 500;
		line-height: 42px;
		color: #3c3c3c;
	}
	::v-deep .el-tree-node__expand-icon {
		position: absolute;
		right: 19px;
		top: 0px;
		// transform: translateY(-50%);
	}
	::v-deep .el-input__suffix {
		cursor: pointer;
		padding-right: 3px;
	}
	::v-deep .el-tree-node__content .el-icon-caret-right:before {
		content: "\e6e0";
		font-weight: 600;
		width: 10px;
		height: 10px;
	}
	::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
		top: 8px;
	}
</style>
